import actionTypes from 'dashboard/actions/bond-renewal/action-types';

export default (state = false, action) => {
  switch (action.type) {
    case actionTypes.FETCH_BOND_RENEWAL_REQUEST:
    case actionTypes.FETCH_BOND_RENEWAL_FAILURE:
    case actionTypes.FETCH_BOND_RENEWAL_SUCCESS: {
      return action.isLoading;
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/bond-renewal/loading-status.js